import { useEffect } from "react"
import {
  useSaleCreateStore,
  initialSaleData,
} from "../stores/useSaleCreateStore"
import useLocalStorage from "../../../hooks/useLocalStorage"
import { SaleForm } from "../components/SaleForm"

export const SaleCreate = () => {
  const { updateSaleData, setEditMode, reset } = useSaleCreateStore()

  // Progressive saving with localStorage
  const [savedData] = useLocalStorage("sale-create-draft", initialSaleData)

  // Reset store and load saved data on mount, ensure we're in create mode
  useEffect(() => {
    reset() // Clear any existing state first
    setEditMode(false) // Ensure we're in create mode
    if (savedData && Object.keys(savedData).length > 0) {
      // Load saved data but exclude boundary_geom to prevent previous boundaries from showing
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { boundary_geom: _boundary_geom, ...savedDataWithoutBoundary } =
        savedData
      updateSaleData(savedDataWithoutBoundary)
    }
  }, [savedData, setEditMode, updateSaleData, reset])

  return (
    <SaleForm
      pageTitle="Create New Sale"
      pageDescription="Follow the steps below to create a new timber sale"
      finalActionLabel="Create Sale"
      localStorageKey="sale-create-draft"
    />
  )
}
